import { IWebMessage } from 'src/app/common/interfaces/webmessage-interface';
import { ISelfReturnRequest } from '../../interfaces/return-list/self-return-request.interface';

export abstract class AbstractReturnPaymentService {
  abstract returnPaymentReasonCodeList(): Promise<any>;
  abstract sendSelfReturn(selfReturnRequest: ISelfReturnRequest): Promise<IWebMessage | undefined>;
}
